module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/2-2cec918ae135a76d8c3780120900a901.svg";